import { ClaimsReportComponent } from '../claims-report/claims-report.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { AcmicService } from '@mapfre-design-library/src/public_api';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, ClaimsReportComponent],
  selector: 'app-no-claims',
  templateUrl: './no-claims.component.html',
  styleUrls: ['./no-claims.component.scss'],
})
export class NoClaimsComponent implements OnInit {
  isAcmic: boolean;
  constructor(private acmicService: AcmicService) {}

  ngOnInit() {
    this.isAcmic = this.acmicService.isACMIC();
  }
}
